const magicNumbers = [2, 8, 20, 28, 50, 82, 126];

export default magicNumbers;